export const SESSION_KEY = 'adpilot_user_data';
export const SESSION_TTL_MS = 3 * 24 * 60 * 60 * 1000; // 3 days, matches app-frontend

export function saveSession(user) {
  const payload = {
    ...user,
    expiresAt: user.expiresAt || Date.now() + SESSION_TTL_MS,
  };
  localStorage.setItem(SESSION_KEY, JSON.stringify(payload));
  return payload;
}

export function loadSession() {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed.expiresAt || Date.now() > parsed.expiresAt) {
      localStorage.removeItem(SESSION_KEY);
      return null;
    }
    // A session must actually look like a verified backend user row — a
    // crafted localStorage value is not a login. account_id is ignored: the
    // B2C model has no Stellair account id.
    if (!parsed.id || !parsed.email || !parsed.sessionToken) {
      localStorage.removeItem(SESSION_KEY);
      return null;
    }
    return parsed;
  } catch {
    localStorage.removeItem(SESSION_KEY);
    return null;
  }
}

export function clearSession() {
  localStorage.removeItem(SESSION_KEY);
}
